<div class="d-flex flex-column">
  <span class="fw-bold primary-text"
    >{{ 'user_edit_overview_l' | translate }}:
    {{ selectionTranslateKeys[changeType()] | translate }}</span
  >

  <hr />

  <div class="d-flex flex-row align-items-center gap-2">
    <rs-web-icon
      [color]="'var(--color-text-secondary, #7c8592)'"
      [icon]="ImmomioIconName.Calendar"
      [size]="16"
    ></rs-web-icon>
    <span class="secondary-text"> {{ now | date: 'dd.MM.yyyy' }} </span>
  </div>

  <span class="fw-bold primary-text mt-3">{{ 'user_edit_overview_title_l' | translate }}:</span>

  <div class="mt-1 secondary-text">
    <ng-content></ng-content>
  </div>
  <ng-content select="[custom]" />
</div>
